module.exports = __webpack_public_path__ + "static/img/rs_js_10.9f7debf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_10.png
// module id = Mkx4
// module chunks = 1